import { useLocalSearchParams } from 'expo-router';
import { useQuery } from 'urql';
import {
  ChatDetailProvider,
  initialChatDetailState,
} from '@/components/Chat/ChatDetailContext';
import { graphql } from '@/gql/graphql';
import ChatHeader from './components/ChatHeader';
import ChatMessageDetail from './components/ChatMessageDetail';
import ChatMessageSheet from './components/ChatMessageSheet';
import ChatMessages from './components/ChatMessages';

const GetChatDetail = graphql(
  /* GraphQL */ `
    query GetChatDetail($chatId: uuid!) {
      chat_by_pk(id: $chatId) {
        id
        unseen_message_count
      }
    }
  `,
);

export default function ChatDetail() {
  const { chatId } = useLocalSearchParams<{ chatId?: string }>();

  const [{ data }] = useQuery({
    query: GetChatDetail,
    variables: {
      chatId: chatId!,
    },
  });

  return (
    <ChatDetailProvider {...initialChatDetailState}>
      <ChatHeader />
      <ChatMessages
        unseenMessageCount={data?.chat_by_pk?.unseen_message_count ?? 0}
      />
      <ChatMessageSheet />
      <ChatMessageDetail />
    </ChatDetailProvider>
  );
}
